import React from "react";
import { Link } from "react-router-dom";
import { SimStockPanel } from "@/components/sim/SimStockPanel";
import { WithOperator } from "@/components/mobile/WithOperator";

const EsimNote = (ops) => ops.some((o) => o.kind === "esim") && (
  <p className="text-xs text-muted-foreground" data-testid="order-sim-esim-note">
    Le eSIM SiMamma sono virtuali: non hanno giacenza e non si ordinano, si vendono direttamente da <Link to="/app/esim-simamma" className="text-primary hover:underline" data-testid="order-sim-esim-link">SiMamma eSIM</Link>.
  </p>
);

export default function OrderSim() {
  return <WithOperator stock choose note={EsimNote} title="Ordina SIM" testid="order-sim-page" description="Ogni operatore ha le sue SIM in plastica: scegli l'operatore e vedi subito quante ne hai in giacenza. Le paghi dal tuo unico plafond servizi Markoo Place (o con carta / bonifico).">
    <SimStockPanel />
  </WithOperator>;
}
